import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

/**
 * Adding Razorpay Content
 */
addFilter( 'wp_travel_payment_gateway_fields_razorpay_checkout', 'wp-travel', (content) => {
    return [ ...content, <RazorPayContent /> ]
});

const RazorPayContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_razorpay_checkout,
        wp_travel_razorpay_checkout,
        wt_test_mode
    } = allData

    const updateRazorPayData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }

    const clientIdDesc = __('Get your credentials <a href="https://razorpay.com/integrations" target="__blank">here</a>', 'wp-travel-razorpay-checkout');

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-razorpay-checkout' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-razorpay-checkout' ) }</p></strong>
            }
            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_razorpay_checkout }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_razorpay_checkout == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_razorpay_checkout: 'yes' == payment_option_razorpay_checkout ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{_wp_travel.setting_strings.payment.enable_razorpay_checkout_note}</p>
                </div>
            </PanelRow>

            {
                payment_option_razorpay_checkout === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.razorpay_checkout_key_id }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ wp_travel_razorpay_checkout && 'undefined' !== typeof wp_travel_razorpay_checkout.api_key ? wp_travel_razorpay_checkout.api_key : '' }
                                    onChange={
                                        (value) => {
                                            updateRazorPayData( 'wp_travel_razorpay_checkout', 'api_key', value );
                                        }
                                    }
                                />
                                <p className="description">{__( 'e.g. test_da0025f5d69d016f...', 'wp-travel-razorpay-checkout' )}</p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.razorpay_checkout_key_secret }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ wp_travel_razorpay_checkout && 'undefined' !== typeof wp_travel_razorpay_checkout.auth_token ? wp_travel_razorpay_checkout.auth_token : '' }
                                    onChange={
                                        (value) => {
                                            updateRazorPayData( 'wp_travel_razorpay_checkout', 'auth_token', value );
                                        }
                                    }
                                />
                                <p className="description">{__( 'e.g. test_da0025f5d69d016f...', 'wp-travel-razorpay-checkout' )}</p>
                                <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <p className="description">{_wp_travel.setting_strings.payment.razorpay_checkout_info}</p>
                    </PanelRow>

                </>
            }
        </>
    )
}